<template>
     <div>
        <div class="w-100 px-5 py-4">
            <!-- TITULO Y ENCABEZADOS -->
            <div>
                <h1>ALTA DE CONTENIDO</h1>
                <h4>Ingrese la información requerida para dar de alta nuevo contenido en el Micrositio</h4>
            </div>
            <!-- Componentes de Paso 1 y 2 -->
            <div class="paso-dos-tres">
                <CFormularioPasoUno @mostrarTooltip="mostrarTooltip"></CFormularioPasoUno>
                <div class="col-8 padding-div-low" v-if="mostrarFormularios" >
                  <ul class="nav nav-tabs" id="nav-tab-formulario-paso-dos" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link active" id="agregar-tab" data-toggle="tab" href="#agregar-contenido" role="tab" aria-controls="agregar-contenido" aria-selected="true">Agregar Contenido</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link disabled" id="ordenar-tab" data-placement="top" v-tooltip:top="tituloToggleOrdenContenido" data-toggle="tab" href="#ordenar-contenido" role="tab" data-original-title="Necesitas al menos guardar un contenido para habilitar la pestaña modificar orden de contenidos" aria-controls="ordenar-contenido" aria-selected="true">Modificar Orden de Contenidos</a>
                    </li>
                  </ul>
                  <div class="nav_tab_formularios">
                    <div class="tab-content" id="myTabContent">
                      <div class="tab-pane fade show active" id="agregar-contenido" role="tabpanel" aria-labelledby="agregar-tab"><CFormularioPasoDos @ocultarTooltip="ocultarTooltip" ref="FormularioPasoDos"></CFormularioPasoDos></div>
                      <div class="tab-pane fade" id="ordenar-contenido" role="tabpanel" aria-labelledby="ordenar-tab"><CFormularioPasoTres></CFormularioPasoTres></div>
                    </div>
                  </div>
                </div>
            </div>
            
        </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import api from '@/../static/js/api'
  import comun from "@/../static/js/comun"
  import CFormularioPasoUno from '@/components/SICPO/Micrositios/Comun/CFormularioPasoUnoMicrositio.vue'
  import CFormularioPasoDos from '@/components/SICPO/Micrositios/Comun/CFormularioPasoDosMicrositio.vue'
  import CFormularioPasoTres from '@/components/SICPO/Micrositios/Comun/CFormularioPasoTresMicrositio.vue'
  import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'

  export default {
      components: {
          CFormularioPasoUno,
          CFormularioPasoDos,
          CFormularioPasoTres
      },
      directives: {
          tooltipF
      },
      data() {
          return {
            mostrarSubidorDeArchivos: false,
            mostrarRealizarLaSubida: false,
            tituloToggleOrdenContenido: '',
            opcion1: '',
            opcion2: ''
          }
      },
      methods: {
        /**
         * Metodo para ocultar la directiva tooltip de la pestaña habilitada
         * @param {String} estado [valor que representa el estado en que se encuentra la directiva]
         */
        ocultarTooltip: function(estado) {
          this.tituloToggleOrdenContenido = estado;
        },
        /**
         * Metodo para mostrar la directiva tooltip de la pestaña habilitada
         * @param {String} estado [valor que representa el estado en que se encuentra la directiva]
         */
        mostrarTooltip: function(estado) {
          this.tituloToggleOrdenContenido = estado;
        },
        /**
         * Función encargada de limpiar variables del store.
         */
        limpiarStore: function() {
          this.$store.dispatch("A_SICPO_Catalogos_establecer007PaginasWeb",{llave: 'catalogoPaginaPasoUno',valor: -1});
          this.$store.dispatch("A_SICPO_Catalogos_establecer008SeccionesDeLaPaginaWeb",{llave: 'catalogoSeccionDePahginaWebPasoUno',valor: -1});
        },
        /**
         * Función encargada de llamar a API para cambiar el estatus enEdicion de la seccion a false (no se esta editando).
         * @param {} next [valor que representa la página a que se va]
         */
        cambiarEstatusDeSeccion: function(next)
        {
            next()
        }
      },
      created() {
        this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCamposRequeridosFormulario",{});
         window.addEventListener('beforeunload', (event) => {
            this.cambiarEstatusDeSeccion();
         })
      },
      mounted() {
      },
      computed: {
        /**
         * Funciones encargadas de modificar variables de store.
         */
        mostrarFormularios() {
           return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_mostrarFormularios;
        },
        mostrarPasoTres() {
           return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_mostrarPasoTres;
        },
        modificoOrdenDeContenidos(){
            return this.$store.getters.Get_SICPO_PaginaWeb_AltaDeContenido_cambioOrdenlistaContenidos;
        }
      },
      /**
       * Función router. Se valida si hay una sección en edición en base al ID y
       * se llama al API para cambiar el estatus enEdicion de la seccion a false (no se esta editando).
       */
      beforeRouteLeave (to, from, next) {
        if(this.mostrarFormularios) {
          let existePerdidaDeCambios = this.$refs.FormularioPasoDos.obtenerExistePerdidaDeCambios();
          if(existePerdidaDeCambios || this.modificoOrdenDeContenidos)
          {
            bootbox.confirm({
              title: "Mensaje del sistema",
              message: "Actualmente se encuentra "+ (existePerdidaDeCambios ? "ingresando información para agregar un nuevo contenido": "") 
                        + (existePerdidaDeCambios && this.modificoOrdenDeContenidos ? " y ":"")
                        + (this.modificoOrdenDeContenidos ? "editando el orden de contenidos.":".") + " Si decide salir sin guardar, perderá los cambios realizados.<br />¿Desea continuar?",
              buttons: {
                cancel: {
                  label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                },
                confirm: {
                  label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Continuar y salir'
                }
              },
              callback: (respuestaSalir) => {
                if (respuestaSalir) {
                  this.limpiarStore();
                  this.cambiarEstatusDeSeccion(next);
                }
                else  {
                  next(false);
                  this.limpiarStore();
                } 
              }
            });
          }else{
            this.limpiarStore();
            this.cambiarEstatusDeSeccion(next);
          }
        } else {
          this.limpiarStore();
          next()
        }
      }
  }
</script>

<style scoped>


.paso-dos-tres{
  color: #161616;
}
  .tipoDePagina_DIV {
      display: flex;
  }

  #subidordearchivos_div {
      text-align: center
  }

  .vr {
      width:1px;
      background-color: white;
      margin-left: 15px;
  }
  .paso-dos-tres{
    display: flex;
  }
  .paso{
    margin: 1em;
    width: 48%;
  }
  h1,h4{
    user-select: none;
  }


  .nav_tab_formularios {
    padding: 25px;
    background-color: var(--blanco-pj);
    box-shadow: 0px 6px 20px 4px #161616;
  }
  .nav-tabs
  {
    border-bottom: 1px solid white;
  }

  .nav-item>a.active, 
  .nav-item>a.active:focus, 
  .nav-item>a.active:hover {
    background-color: var(--verde-pj);
    color: white;
    border-bottom: 1px solid #323335;
  }
  .nav-item>a{
    border-bottom: 1px solid white;
   
  }

  .nav-item{
    background-color: var(--verde-pj-100);
  }

</style>


// WEBPACK FOOTER //
// src/components/SICPO/Micrositios/AltaContenidoMicrositio.vue